import { onCLS, onLCP, onFID, Metric } from 'web-vitals';

import { Method, Mode } from 'common/services/http/types';

const onPostMetrics = (url: string) => (data: Metric) => {
  const { name, navigationType, rating, value } = data;

  return fetch(url, {
    method: Method.Post,
    mode: Mode.Cors,
    body: JSON.stringify({ message: { name, navigationType, rating, value } }),
  });
};

const reportWebVitals = (postUrl: string) => {
  if (BUILD_ENV === 'production') {
    onCLS(onPostMetrics(postUrl));
    onLCP(onPostMetrics(postUrl));
    onFID(onPostMetrics(postUrl));
  }
};

export default reportWebVitals;
